import $script from 'scriptjs';

let externalScriptService = () => {
  return {
    load: url => {
      return new Promise((resolve) => $script(url, resolve));
    }
  }
}

externalScriptService.$inject = [];

export default externalScriptService;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/core/services/externalScript.service.js